import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import * as Types from './purchasePlus_graphql'

export const GetCreateProductValuesInvoiceDocument = gql`
  query GetCreateProductValuesInvoice($invoiceId: Int!) {
    invoice(id: $invoiceId) {
      id
      department {
        id
        name
      }
      account {
        id
        codedName
      }
    }
  }
` as unknown as DocumentNode<
  Types.GetCreateProductValuesInvoiceQuery,
  Types.GetCreateProductValuesInvoiceQueryVariables
>
